import createFormValues from './createFormValues.js';
import plain from './structure/plain/index.js';
export default createFormValues(plain);